module.exports = __webpack_public_path__ + "static/media/axonLogo.e2c42b61.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/axonLogo.png
// module id = 790
// module chunks = 0